<template>
  <Teleport v-if="active" to="#modals">
    <div
      v-if="active"
      ref="main"
      class="dragmodal"
      :class="classs"
      v-bind="scopeAttrs"
      :style="!dragPositionForContainer ? calculatedPosition : {}"
      @mousedown.self="handleCancel"
      @keyup.esc="handleCancel">
      <div v-if="!noBackdrop" class="dragmodal_backdrop" @mousedown.prevent="overlayClick"></div>
      <transition name="genie">
        <div
          v-if="containerActive"
          ref="container"
          class="dragmodal_container"
          :style="dragPositionForContainer ? calculatedPosition : {}"
          @mousedown.left.self="$emit('container')">
          <!-- <div class="dragmodal_container" @mousedown.left.self="$emit('container')" v-draggable="draggableValue"> -->
          <header
            v-if="!hiddenHeader"
            :ref="handleId"
            class="dragmodal_container_header d-flex align-items-center px-3"
            :class="{ 'is-grabbing': isGrabbing, 'is-draggable': isDraggable }"
            @mousedown="startMove">
            <slot name="header"></slot>
            <div v-if="!hideExit" class="dragmodal_close" @click.prevent="handleCancel">
              <i class="icon icon-cancel"></i>
            </div>
            <a
              v-if="hasResetCalculatedPosition && hasPosition"
              class="dragmodal-reset-position typo-p12 weight-500 absolute right-10"
              href="#"
              @click="resetCalculatedPosition"
              >Reset</a
            >
          </header>

          <section class="dragmodal_container_body">
            <slot></slot>
          </section>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script>
import scopeAttr from '@/mixins/scopeAttr.ts';
// import { Draggable } from "@/packages/draggable";
// import clearSelection from "@/utils/clearSelection.ts";

export default {
  name: 'ModalDraggable',
  // directives: {
  // Draggable
  // },
  mixins: [scopeAttr],
  props: {
    noBackdrop: {
      type: Boolean,
      default: false,
    },
    hideExit: {
      type: Boolean,
      default: false,
    },
    preventBackdrop: {
      type: Boolean,
      default: false,
    },
    classs: String,
    active: {
      type: Boolean,
      default: false,
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
    dragPositionForContainer: {
      type: Boolean,
      default: true,
    },
    hasResetCalculatedPosition: {
      type: Boolean,
      default: false,
    },
    hiddenHeader: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['container', 'cancel'],
  data: () => ({
    containerActive: false,
    isGrabbing: false,
    handleId: 'modalHeader',
    boundingElementId: 'main',
    // draggableValue: {
    //   handle: undefined,
    //   boundingElement: undefined
    // },
    position: {
      top: null,
      left: null,
    },
  }),
  computed: {
    calculatedPosition() {
      if (!this.hasPosition) {
        return {};
      }
      const left = this.rangeCheck(this.position.left);
      const top = this.rangeCheck(this.position.top, 'height');
      return {
        top: top + 'px !important',
        left: left + 'px !important',
        position: 'absolute',
        right: 'auto',
        bottom: 'auto',
      };
    },
    hasPosition() {
      if (this.position.top == null || this.position.left == null) {
        return false;
      }
      return true;
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(newV) {
        this.$nextTick(() => {
          this.containerActive = newV;
          // if (newV) {
          //   this.setDraggable();
          // }
        });
      },
    },
    // containerActive(newV) {
    //   if (newV == true) {
    //     this.$nextTick(() => {
    //       this.setDraggable();
    //     });
    //   }
    // },
  },
  created() {},
  mounted() {
    // this.setDraggable();
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
      if (this.hasResetCalculatedPosition) return;
      this.position.top = null;
      this.position.left = null;
    },
    overlayClick() {
      if (this.preventBackdrop) {
        return;
      }
      this.handleCancel();
    },
    // setDraggable() {
    //   this.draggableValue.handle = this.$refs[this.handleId];
    //   this.draggableValue.boundingElement = this.$refs[this.boundingElementId];
    // },
    rangeCheck(val, type = 'width') {
      if (val < 0) {
        return 0;
      }
      const $container = this.$refs && this.$refs.container;

      let max = window.innerWidth;
      let offset = $container && $container.offsetWidth;
      if (type != 'width') {
        max = window.innerHeight;
        offset = $container && $container.offsetHeight;
      }
      const allow = max - (offset || 0.85 * max);
      if (val > allow) {
        return allow;
      }
      return val;
    },
    startMove(evt) {
      if (!this.isDraggable) return;
      evt.preventDefault();
      this.isGrabbing = true;
      const { clientX: initX, clientY: initY } = evt;
      const $handler = this.$refs && this.$refs[this.handleId];
      let hX = 0,
        hY = 0;
      if ($handler != undefined) {
        const rect = $handler.getBoundingClientRect();
        hY = rect.top;
        hX = rect.left;
      }
      const diffX = initX - hX;
      const diffY = initY - hY;
      const onMouseMove = (e) => {
        e.preventDefault();
        const { clientX: cX, clientY: cY } = e;
        this.position.left = cX - diffX;
        this.position.top = cY - diffY;
      };

      const onMouseUp = (e) => {
        window.removeEventListener('mousemove', onMouseMove);
        // window.removeEventListener("touchmove", onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        // window.removeEventListener("touchend", onMouseUp);
        this.isGrabbing = false;
      };

      window.addEventListener('mousemove', onMouseMove);
      // window.addEventListener("touchmove", onMouseMove);

      window.addEventListener('mouseup', onMouseUp);
      // window.addEventListener("touchend", onMouseUp);
    },
    resetCalculatedPosition() {
      this.position = {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

$baseIndex: $modalIndex;
$header-size: 50px;

.dragmodal {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include flex-center;

  &.share-library-ob {
    .dragmodal_container {
      padding: 0px !important;
      height: 100vh;
      max-height: none;
      margin: 0px;
      .dragmodal_container_header {
        display: none !important;
      }
    }
  }

  &.modal-library {
    .dragmodal_container {
      max-height: calc(100vh - 96px);
      height: 100vh;
    }
    .dragmodal_close {
      right: 16px;
    }
  }
  &.modal-preview-element {
    .dragmodal_container {
      max-height: calc(100vh - 96px);
      height: auto;
      max-width: 900px;
    }
    .dragmodal_close {
      right: 16px;
    }
    .dragmodal_container_body {
      height: 100%;
      display: flex;
    }
  }

  &_backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(#000, 0.5);
  }

  &_container {
    width: 100%;
    margin: 48px 64px;
    width: 100%;
    margin: 48px 64px;
    position: relative;
    background: $light3;
    height: 85vh;
    max-height: 760px;
    display: flex;
    z-index: 10;
    flex-direction: column;
    border-radius: $radius;
    overflow: hidden;
    @media screen and (max-width: 576px) {
      min-width: unset;
    }

    &_header {
      position: relative;
      background: $light1;
      height: $header-size;
      min-height: $header-size;
      border-bottom: 1px solid $light3;
      &.is-draggable {
        cursor: grab;
      }
      &.is-grabbing {
        cursor: grabbing;
      }
    }

    &_actions {
      position: relative;
    }

    &_body {
      flex: 1;
      overflow: overlay;
      @-moz-document url-prefix() {
        overflow: auto;
      }
    }
  }

  $btn-gap: 9px;

  &_close {
    position: absolute;
    top: $btn-gap;
    right: $btn-gap;
    z-index: 1;
    margin-left: auto;
    top: 50%;
    transform: translateY(-50%);
    &:hover {
      background-color: rgba($dark0, 0.1);
    }
    width: 24px;
    height: 24px;
    font-size: 18px;
    cursor: pointer;
    @include flex-center;
    border-radius: 3px;
  }

  &_btn {
    @include flex-center;
    color: $text-light-low;
    width: $header-size - $btn-gap * 2;
    height: $header-size - $btn-gap * 2;

    font-size: 28px;
    cursor: pointer;
    border-radius: 50%;
    &:hover {
      background: $light2;
    }
  }
}

// ANIMATION

// @keyframes spaceInUp {
//   0% {
//     opacity: 0;
//     transform-origin: 50% 0%;
//     transform: scale(0.2) translate(0%, -200%);
//   }

//   100% {
//     opacity: 1;
//     transform-origin: 50% 0%;
//     transform: scale(1) translate(0%, 0%);
//   }
// }
// @keyframes spaceOutUp {
//   0% {
//     opacity: 1;
//     transform-origin: 50% 0%;
//     transform: scale(1) translate(0%, 0%);
//   }

//   100% {
//     opacity: 0;
//     transform-origin: 50% 0%;
//     transform: scale(0.2) translate(0%, -200%);
//   }
// }

// .genie {
//   &-enter {
//     &-active {
//       animation: spaceInUp 0.5s;
//     }
//     // &-to {
//     // }
//   }
//   &-leave {
//     &-active {
//       animation: spaceOutUp 0.5s;
//     }
//     // &-to {
//     // }
//   }
// }
</style>
